import React from "react";
import { Route, useRouteMatch, Switch, Redirect } from "react-router-dom";
import MoveRemoteDetail from "./moveRemoteDetail";
import ReserveDetail from "./reserveDetail";
import ReserveDetailV2 from "./reserveDetail/indexV2";
// import ReturnDetail from "./returnDetail";
import SettleDetail from "./salesSettlementDetail";
import useQuery from "../../../hooks/useQuery";
import EnvirlInspectionSheetDetail from "./envirInspectionSheetDetail";
import RepairOrderDetail from "./repairOrderDetail";
import DetailsAppearanceDamage from "./envirInspectionSheetDetail/components/detailsAppearanceDamage";
import SignatureTemplate from "../components/SignatureTemplate";
import GetAndReturnCarServiceDetail from "./GetAndReturnCarServiceDetail";
import MapView from "./mapView";

export default function OrderDetail() {
  const { path } = useRouteMatch();
  const query = useQuery();

  // 按照不同服务子单类型分配路由
  return (
    <Switch>
      {/* ?ssReserveOrderCode=xxxx */}
      <Route path={`${path}/moveRemoteDetail`}>
        <MoveRemoteDetail />
      </Route>
      {/* ?reserveId=xxxx */}
      <Route path={`${path}/reserveDetail`}>
        <ReserveDetail />
      </Route>
      <Route path={`${path}/reserveDetailV2`}>
        <ReserveDetailV2 />
      </Route>
      {/* ?drivingOrderRecordSubId=xxxx */}
      {/* 旧：取送车服务详情 */}
      {/* <Route path={`${path}/returnDetail`}>
        <ReturnDetail />
      </Route> */}
      {/* 新：取送车服务详情 */}
      <Route path={`${path}/getAndReturnCarDetail`}>
        <GetAndReturnCarServiceDetail />
      </Route>
      {/* ?aroundCheckOrderNo=xxxx */}
      <Route path={`${path}/envirlInspectionSheetDetail`}>
        <EnvirlInspectionSheetDetail />
      </Route>
      <Route
        path={`${path}/settlementDetail`}
        render={(props) => {
          const salesSettlementCode = query.get("salesSettlementCode");
          const search = props.location.search;
          return salesSettlementCode ? (
            <Redirect to={`${path}/salesSettlementDetail${search}`}></Redirect>
          ) : (
            <RepairOrderDetail />
          );
        }}
      ></Route>
      {/* ?salesSettlementCode=xxxx&subOderType=302   外销单结算详情*/}
      <Route path={`${path}/salesSettlementDetail`}>
        <SettleDetail />
      </Route>
      {/* <Route path={`${path}/settlementDetail`}>
        <RepairOrderDetail />
      </Route> */}
      <Route path={`${path}/detailsAppearanceDamage`}>
        <DetailsAppearanceDamage />
      </Route>
      <Route path={`${path}/signatureTemplate`}>
        <SignatureTemplate />
      </Route>
      {/* 维修服务单详情页，支持施工单号和结算单号 支持维修结算单号：repairSettlementCode和旅程单号 ：journeyOrderCode */}
      <Route path={`${path}/repairOrderDetail`}>
        <RepairOrderDetail />
      </Route>
      {/* 地图页面 */}
      <Route path={`${path}/mapView`}>
        <MapView />
      </Route>
    </Switch>
  );
}
